export default __webpack_public_path__ + "static/media/dune.cbd0ce21.jpg";